import type { DocPageContent } from '../docs-content'

const page = {
  order: 12,
  slug: 'audio',
  title: '音频编辑',
  description: '增益、淡入淡出、音高、均衡器、电平表、混音器、静音和填充词。',
  category: '创意工具',
  sections: [
    {
      title: '片段音频',
      items: [
        '以分贝为单位调整片段增益。',
        '添加淡入和淡出效果。',
        '调整半音和音分级的音高变化。',
        '当单个片段需要音色塑造时，使用逐片段均衡器。',
      ],
    },
    {
      title: '混音',
      items: [
        '使用轨道均衡器进行全轨道的音调调整。',
        '使用轨道推子和主总线进行混音平衡。',
        '观察立体声电平表以检查削波和相对电平。',
        '记住监听音量仅影响本地播放。',
      ],
    },
    {
      title: '清理工具',
      items: [
        '使用"移除静音"查找并移除静音范围。',
        '当转录稿和音频置信度支持时，使用"移除填充词"。',
        '在应用破坏性编辑操作之前预览移除范围。',
      ],
    },
  ],
} satisfies DocPageContent

export default page